/** UTF-8 BOM so Excel on Windows opens Hebrew correctly */
export const CSV_UTF8_BOM = '\uFEFF';

export function downloadCsvUtf8Bom(csvBody, filename) {
  const normalized = csvBody.replace(/^\uFEFF/, '').replace(/\n/g, '\r\n');
  const blob = new Blob([CSV_UTF8_BOM + normalized], {
    type: 'text/csv;charset=utf-8;'
  });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
}

/** Read uploaded CSV as UTF-8 (handles BOM from Excel exports). */
export async function readCsvFileAsUtf8(file) {
  const buffer = await file.arrayBuffer();
  const text = new TextDecoder('utf-8').decode(buffer);
  return text.replace(/^\uFEFF/, '');
}

/** Parse one CSV row with quoted fields (commas/apostrophes inside quotes). */
export function parseCsvLine(line) {
  const result = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];

    if (char === '"') {
      if (inQuotes && line[i + 1] === '"') {
        current += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === ',' && !inQuotes) {
      result.push(current.trim());
      current = '';
    } else {
      current += char;
    }
  }

  result.push(current.trim());
  return result;
}
